import React from "react";
import { Breadcrumb, BreadcrumbItem } from "shards-react";
import { useTranslation } from "react-i18next";
const MenuBar = (props) => {
  const { menu, mode } = props;
  const { t, i18n } = useTranslation();
  return (
    <Breadcrumb>
      {mode !== "contentsetting" && (
        <BreadcrumbItem>
          <a href="/">{t("common:menu.Home")}</a>
        </BreadcrumbItem>
      )}
      {menu &&
        menu.map((item, key) => (
          <BreadcrumbItem key={key}>
            <a href={item.path}>{item.title}</a>
          </BreadcrumbItem>
        ))}
    </Breadcrumb>
  );
};
export default MenuBar;
